import * as yup from "yup";

export const schema = yup
  .object({
    JBTnumber: yup.number().required(),
  })
  .required();
